import http from "../../http";

/** 支付商户配置 — /resident/api/resident/housePayMerchant */
const BASE = "/resident/api/resident/housePayMerchant";

const payMerchant = {
  selectPage(r) {
    return http.get(`${BASE}/page`, r);
  },
  selectById(r) {
    return http.get(`${BASE}/detail`, r);
  },
  save(r) {
    return http.payload(`${BASE}/save`, r);
  },
  updateStatus(r) {
    return http.tip.post(`${BASE}/updateStatus`, r);
  },
  resolveChannel(r) {
    return http.get(`${BASE}/resolveChannel`, r);
  },
};

export default payMerchant;
